import React from 'react'
import { Box } from '@mui/material'
import { PlayGame } from '../components/PlayGame'

interface PlayGameWithIntroductionPageProps {
  className?: string
}

/** The tutorial the participant plays before their first game; the backend credits it, so this page writes nothing. */
export const PlayGameWithIntroductionPage: React.FC<PlayGameWithIntroductionPageProps> = ({ className = '' }) => {
  return (
    <Box className={className}>
      <PlayGame gameParams={{ introduction: true }} />
    </Box>
  )
}
